import { render, staticRenderFns } from "./render-radio.vue?vue&type=template&id=22f6fa2d&scoped=true&"
import script from "./render-radio.vue?vue&type=script&lang=ts&"
export * from "./render-radio.vue?vue&type=script&lang=ts&"
import style0 from "./render-radio.vue?vue&type=style&index=0&id=22f6fa2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6fa2d",
  null
  
)

export default component.exports